var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlittrts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.8072 8.8978L6.246 7.8927C6.63655 6.9983 7.33945 6.2863 8.21625 5.8971L9.4241 5.36095C9.8081 5.1905 9.8081 4.63184 9.4241 4.46139L8.25395 3.94197C7.3546 3.54276 6.6391 2.80441 6.25525 1.87947L5.81075 0.808365C5.6458 0.410883 5.09659 0.410884 4.93165 0.808365L4.48713 1.87946C4.10328 2.80441 3.38776 3.54276 2.48842 3.94197L1.31829 4.46139C0.934268 4.63184 0.934268 5.1905 1.31829 5.36095L2.52615 5.8971C3.40294 6.2863 4.10585 6.9983 4.49637 7.8927L4.9352 8.8978C5.10388 9.2841 5.6385 9.2841 5.8072 8.8978ZM10.2007 11.3449L10.3241 11.0621C10.5441 10.5578 10.9403 10.1562 11.4347 9.9366L11.8149 9.76765C12.0206 9.6763 12.0206 9.37745 11.8149 9.2861L11.456 9.1266C10.9489 8.9013 10.5456 8.4849 10.3293 7.96345L10.2026 7.6578C10.1142 7.4448 9.81975 7.4448 9.7314 7.6578L9.6047 7.96345C9.3885 8.4849 8.98515 8.9013 8.478 9.1266L8.11905 9.2861C7.91345 9.37745 7.91345 9.6763 8.11905 9.76765L8.49925 9.9366C8.9937 10.1562 9.3899 10.5578 9.6099 11.0621L9.73335 11.3449C9.82365 11.552 10.1103 11.552 10.2007 11.3449Z",
    fill: "#969CA6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlittrts);
export default __webpack_public_path__ + "static/media/glittrts.6b9df16748aeb36d63ffdfa75ce53a9d.svg";
export { ForwardRef as ReactComponent };